import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';


export const AuthGuard: CanActivateFn = async (route, state) => {
  console.log('[AUTH GUARD] Checking authentication');
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for storage system to be initialized
  console.log('[AUTH GUARD] Waiting for storage initialization');
  await authService.waitForStorageReady();
  console.log('[AUTH GUARD] Storage initialized, checking authentication');

  const isAuthenticated = await authService.isAuthenticated();
  console.log('[AUTH GUARD] Is authenticated:', isAuthenticated);

  if (isAuthenticated) {
    console.log('[AUTH GUARD] Access granted');
    return true;
  } else {
    console.log('[AUTH GUARD] Access denied, redirecting to login');
    router.navigate(['login']);
    return false;
  }
};
